module.exports = __webpack_public_path__ + "static/portfolio-image-24bc3b043bb0568808a74205ed2d971a.jpg";